export const anchorOrigin = { vertical: "top", horizontal: "right" };
export const autoHideDuration = 3500;
export const maxSnack = 3;